import config from '../config'

export function cdnUrlProduto (id, cacheHash = '') {
    return `${config.cdn}/produtos/${id}/${id}.jpg?c=${cacheHash}`
}

export function cdnApi (id) {
    return `${config.cdn}/v1/produtos/${id}`
}

export function cdnUrl (path) {
    return `${config.cdn}/${path}`
}

export function cdnUrlUpload (id, name) {
    return `${config.cdn}/v1/produtos/${id}?name=${name}&width=500&height=500`
}

export function cdnUrlDelete (id, name) {
    return `${config.cdn}/v1/produtos/${id}?name=${name}`
}